export type SelectableCollectionItem = {
  id: string | number;
  [key: string | number | symbol]: unknown;
};

export const selectableCollectionItemGuard = (item: unknown): item is SelectableCollectionItem => {
  return ['string', 'number'].includes(typeof (item as SelectableCollectionItem).id);
};
